// Determine if viewport is within tablet dimensions.
export default function () { // eslint-disable-line func-names
  return matchMedia('screen and (min-width: 768px)').matches;
}
